import React from 'react';
import EnetpulseWidget from '../EnetpulseWidget.jsx';
import ExpandableBox from './ExpandableBox.jsx';
import { appContext } from '../../util/decorators';

@appContext
export default class LeagueResults extends React.PureComponent {
  render() {
    const { stage } = this.props;

    if (!stage) return null;

    return (
      <div className="league-table">
        <h3>{this.context.app.t('LeagueTables.result')}</h3>
        <ExpandableBox initialHeight="200px">
          <EnetpulseWidget widgetType="stage_results" params={`${stage}/0/20/0`} />
        </ExpandableBox>
      </div>
    );
  }
}

LeagueResults.propTypes = {
  stage: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/LeagueResults.jsx